/* NKS display-currency switcher (USD / EUR / GBP) - shown on product pages only, right under the price
   (2026-10-22: removed from the header on desktop + mobile).
   Display only: prices on the storefront are converted with Shopify's daily
   rates (cdn.shopify.com/s/javascripts/currencies.js). Checkout and payment
   stay in the store currency (USD). The choice is remembered per visitor.
   USD visitors (the default) only get the selector: rates and text tracking start on the first switch.

   2026-10-29 fix (v59): the page "shook" and never switched to EUR/GBP when the browser auto-translates
   the site (e.g. Chrome translating English -> Hebrew). The translator re-renders every price we rewrite
   from its own stored "$" text, we convert it again, and the two loop forever.
   - every price element (and the USD note) is marked notranslate / translate="no" from page load,
     so the translator leaves prices alone (they need no translation anyway);
   - a per-node loop breaker stops rewriting any text that keeps being changed back by someone else;
   - the selector font is 16px on phones so iOS Safari no longer zooms the page on tap
     (the old "font: 600 12px/1 inherit" shorthand was invalid and dropped). */
(function () {
  'use strict';
  if (window.__nksCurrency) return;
  window.__nksCurrency = true;

  var BASE = 'USD';
  var CURRENCIES = { USD: { symbol: '$', locale: 'en-US' }, EUR: { symbol: '€', locale: 'en-IE' }, GBP: { symbol: '£', locale: 'en-GB' } };
  var FALLBACK = { USD: 1, EUR: 1.124, GBP: 1.333 };        // USD value of one unit
  var KEY = 'nks_currency';
  var rates = null;
  var current = BASE;
  try { current = localStorage.getItem(KEY) || BASE; } catch (e) {}
  if (!CURRENCIES[current]) current = BASE;

  var NOTE = '* Prices in {c} are approximate. Checkout is in USD; PayPal converts automatically to your currency.';

  // ---------- styles ----------
  var css = '' +
    '.nks-cur-wrap{display:flex;align-items:center;gap:10px;margin:10px 0 6px}' +
    '.nks-cur{appearance:none;-webkit-appearance:none;border:1px solid rgba(60,16,83,.18);background:#fff;color:#3c1053;' +
      'font-family:inherit;font-weight:600;font-size:12px;line-height:1;letter-spacing:.06em;' +
      'padding:8px 22px 8px 10px;border-radius:20px;cursor:pointer;height:32px;' +
      'background-image:linear-gradient(45deg,transparent 50%,#3c1053 50%),linear-gradient(135deg,#3c1053 50%,transparent 50%);' +
      'background-position:calc(100% - 12px) 13px,calc(100% - 8px) 13px;background-size:4px 4px,4px 4px;background-repeat:no-repeat}' +
    '@media (max-width:749px){.nks-cur{font-size:16px;height:36px;background-position:calc(100% - 12px) 15px,calc(100% - 8px) 15px}}' +
    '.nks-cur:focus-visible{outline:2px solid #3c1053;outline-offset:2px}' +
    '.nks-cur-label{font-size:13px;letter-spacing:.04em;opacity:.8}' +
    '.nks-cur-note{display:block;font-size:12px;line-height:1.4;opacity:.75;margin-top:6px}' +
    '';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ---------- keep translators (Chrome / Google Translate) away from prices ----------
  var PRICE_BOXES = '.price,.price-item,.totals,.totals__total-value,.cart-item__price-wrapper,.unit-price,.cart-drawer__footer .totals,.nks-cur-note';
  function shield(el) {
    if (!el || el.nodeType !== 1) return;
    if (!el.classList.contains('notranslate')) el.classList.add('notranslate');
    if (el.getAttribute('translate') !== 'no') el.setAttribute('translate', 'no');
  }
  function shieldPrices(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(PRICE_BOXES)) shield(root);
    var list = root.querySelectorAll ? root.querySelectorAll(PRICE_BOXES) : [];
    for (var i = 0; i < list.length; i++) shield(list[i]);
  }

  // ---------- rates ----------
  function loadRates(cb) {
    if (rates) return cb();
    if (window.Currency && window.Currency.rates && window.Currency.rates.EUR) { rates = window.Currency.rates; return cb(); }
    var s = document.createElement('script');
    s.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
    s.async = true;
    s.onload = function () { rates = (window.Currency && window.Currency.rates) || FALLBACK; cb(); };
    s.onerror = function () { rates = FALLBACK; cb(); };
    document.head.appendChild(s);
  }
  function rate(c) { return (rates && rates[c]) || FALLBACK[c]; }

  // ---------- price text conversion ----------
  var MONEY = /\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(\s*USD)?/g;
  var SKIP = 'script,style,textarea,input,select,option,noscript,.nks-cur-wrap,.facets__price,.price-range,[data-nks-skip]';
  var orig = new WeakMap();      // text node -> original USD text
  var shown = new WeakMap();     // text node -> text we wrote
  var hits = new WeakMap();      // text node -> {n, t} recent outside rewrites (loop breaker)
  var MAX_FIGHTS = 6, FIGHT_WINDOW = 2000;

  function fmt(v, c) {
    try { return new Intl.NumberFormat(CURRENCIES[c].locale, { style: 'currency', currency: c, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return CURRENCIES[c].symbol + v.toFixed(2); }
  }
  function convertText(t, c) {
    return t.replace(MONEY, function (m, num) {
      var usd = parseFloat(num.replace(/,/g, ''));
      if (isNaN(usd)) return m;
      return fmt(usd * rate(BASE) / rate(c), c);
    });
  }
  function eligible(node) {
    var v = node.nodeValue;
    if (!v || v.length > 60 || v.indexOf('$') < 0 || !/\$\s?\d/.test(v)) return false;
    var p = node.parentElement;
    return p && !p.closest(SKIP);
  }
  // true when something else keeps changing this node back right after we write it
  function fighting(node) {
    var now = Date.now(), h = hits.get(node);
    if (!h || now - h.t > FIGHT_WINDOW) h = { n: 0, t: now };
    h.n++;
    hits.set(node, h);
    return h.n > MAX_FIGHTS;
  }
  function apply(node) {
    var now = node.nodeValue;
    if (shown.has(node) && shown.get(node) !== now && fighting(node)) return;   // loop breaker
    if (shown.get(node) !== now) { orig.set(node, now); }   // new or theme-updated text
    var o = orig.get(node);
    var out = current === BASE ? o : convertText(o, current);
    if (node.parentElement) shield(node.parentElement);
    if (now !== out) node.nodeValue = out;
    shown.set(node, out);
    if (current !== BASE && node.parentElement) node.parentElement.setAttribute('title', o.trim());
    else if (node.parentElement && node.parentElement.getAttribute('title') === (o || '').trim()) node.parentElement.removeAttribute('title');
  }
  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { if (eligible(root) || orig.has(root)) apply(root); return; }
    if (root.nodeType !== 1 || root.closest && root.closest(SKIP)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { if (eligible(n) || orig.has(n)) apply(n); }
  }
  function refreshAll() {
    scan(document.body);
    notes();
  }

  // ---------- "charged in USD" notes ----------
  function notes() {
    var targets = document.querySelectorAll('.product__info-container .price, .totals, mini-cart .button-container');
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i], nx = t.nextElementSibling;
      var has = nx && nx.classList && nx.classList.contains('nks-cur-note');
      if (current === BASE) { if (has) nx.remove(); continue; }
      var txt = NOTE.replace('{c}', current);
      if (!has) {
        nx = document.createElement('small'); nx.className = 'nks-cur-note notranslate';
        nx.setAttribute('translate', 'no'); nx.setAttribute('data-nks-skip', '');
        t.parentNode.insertBefore(nx, t.nextSibling);
      }
      if (nx.textContent !== txt) nx.textContent = txt;
    }
  }

  // ---------- selector ----------
  function buildSelect() {
    var wrap = document.createElement('span');
    wrap.className = 'nks-cur-wrap notranslate';
    wrap.setAttribute('translate', 'no');
    var lab = document.createElement('span'); lab.className = 'nks-cur-label'; lab.textContent = 'Currency'; wrap.appendChild(lab);
    var sel = document.createElement('select');
    sel.className = 'nks-cur';
    sel.setAttribute('aria-label', 'Display currency');
    ['USD', 'EUR', 'GBP'].forEach(function (c) {
      var o = document.createElement('option'); o.value = c; o.textContent = CURRENCIES[c].symbol + ' ' + c; if (c === current) o.selected = true; sel.appendChild(o);
    });
    sel.addEventListener('change', function () { setCurrency(sel.value); });
    wrap.appendChild(sel);
    return wrap;
  }
  function placeSelect() {
    // one selector per product block (product page + quick view), right after its price
    var boxes = document.querySelectorAll('.product__info-container');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], price = box.querySelector('.price');
      if (!price || box.querySelector('.nks-cur-wrap')) continue;
      var anchor = price.parentElement && price.parentElement.parentElement === box ? price.parentElement : price;
      anchor.parentNode.insertBefore(buildSelect(), anchor.nextSibling);
    }
  }

  function setCurrency(c) {
    if (!CURRENCIES[c]) return;
    current = c;
    try { localStorage.setItem(KEY, c); } catch (e) {}
    var sels = document.querySelectorAll('.nks-cur');
    for (var i = 0; i < sels.length; i++) sels[i].value = c;
    loadRates(function () { refreshAll(); if (c !== BASE) watch(true); });
  }

  // ---------- watching ----------
  // light mode (USD): re-place selectors and shield new prices when product blocks / cart appear;
  // full mode (EUR/GBP): also convert prices the theme re-renders (variants, cart drawer)
  var watcher = null, full = false;
  function watch(withText) {
    if (watcher && (full || !withText)) return;
    if (watcher) watcher.disconnect();
    full = !!withText;
    var pending = [], timer = null;
    watcher = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') { if (full) pending.push(m.target); }
        else for (var j = 0; j < m.addedNodes.length; j++) pending.push(m.addedNodes[j]);
      }
      if (!timer) timer = setTimeout(function () {
        var list = pending; pending = []; timer = null;
        for (var k = 0; k < list.length; k++) {
          var node = list[k];
          if (!node.isConnected) continue;
          if (node.nodeType === 1) shieldPrices(node);
          if (full) scan(node);
        }
        placeSelect();
        if (full) notes();
      }, 60);
    });
    watcher.observe(document.body, full ? { childList: true, subtree: true, characterData: true } : { childList: true, subtree: true });
  }

  // ---------- boot ----------
  function boot() {
    shieldPrices(document.body);   // before any translator runs, in every currency
    placeSelect();
    if (current === BASE) return watch(false);
    loadRates(function () { refreshAll(); watch(true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
